/**
 * Adapptio Function extensions base library.
 *
 * @package ext-functions-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ItemRegistry } from "@adapptio/lib-shared";
import { TGenericFunctionDefinition } from "@adapptio/lib-blueprint";
import { IAppClient, ITranslationManager } from "@adapptio/lib-core";
import { registerFunctions } from ".";

export const registerExtension = (app: IAppClient): void => {
	
	registerFunctions(
		app.get("functionRegistry"),
		app.get("translationManager")
	);

};

export const registerStandalone = (
	registry: ItemRegistry<TGenericFunctionDefinition>,
	translationManager: ITranslationManager
): void => {

	registerFunctions(registry, translationManager);

};